import { 
    WEB_CUSTOMER_API_ENDPOINT, 
    _ADMINISTRATOR_API_ENDPOINTS, 
    _API_ENDPOINT, 
    _BROTHERPLUS_C4C_API_ENDPOINTS, 
    _ECOPRO_C4C_API_ENDPOINTS, 
    _HARDWARE_API_ENDPOINTS 
} from "../constants/AppConstants";

const excludedAPIEndpoints = [
    _API_ENDPOINT.BOL_API,
    _API_ENDPOINT.BOL.GET_USERACCOUNT_INFO_BIL,
    _API_ENDPOINT.STORE_NATIVE_APP_LOGS,
    WEB_CUSTOMER_API_ENDPOINT.GET_PRINTERS_TYPE_LIST, 
    WEB_CUSTOMER_API_ENDPOINT.GET_PRINTERS_MODEL_LIST, 
    WEB_CUSTOMER_API_ENDPOINT.FETCH_PLAN,
    _API_ENDPOINT.FETCH_PLAN_LANDING, 
    _API_ENDPOINT.GET_BENEFIT_OF_SUPPLIES, 
    WEB_CUSTOMER_API_ENDPOINT.GET_PROMOTION_BANNER_STATUS, 
    _ADMINISTRATOR_API_ENDPOINTS.GET_FEATURE_SWITCH_ITEMS_VALUE,
    _HARDWARE_API_ENDPOINTS.GET_HW_PRINTER_BY_FEATURES,
    _HARDWARE_API_ENDPOINTS.GET_HW_PRINTER_FEATURES_BY_PRINTER_TYPE,
    _HARDWARE_API_ENDPOINTS.GET_HW_SERVICE_PLAN,
    _HARDWARE_API_ENDPOINTS.GET_NEW_PRINTER_BUNDLE_SERVICE_PLAN,
    _ADMINISTRATOR_API_ENDPOINTS.GET_FEATURE_SWITCH_ITEMS_VALUES,
    _HARDWARE_API_ENDPOINTS.GET_HWINC_PRINTER_STOCK
]

const ECOPRO_C4C_Endpoints_Excluded = Object.values(_ECOPRO_C4C_API_ENDPOINTS);
const BROTHERPLUS_C4C_Endpoints_Excluded = Object.values(_BROTHERPLUS_C4C_API_ENDPOINTS);

const ApiEndpoints_ExcludeAuthTokenValidation = [
   ...excludedAPIEndpoints,
   ...ECOPRO_C4C_Endpoints_Excluded,
   ...BROTHERPLUS_C4C_Endpoints_Excluded
]

export default ApiEndpoints_ExcludeAuthTokenValidation;